"use client"
import React, { FC, useEffect, useState } from 'react';

import LabelComponent from './label-component';

interface Props {
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  label?: string;
  type?: React.HTMLInputTypeAttribute | undefined;
  max?: string;
  id?: string;
  name?: string;
}

const TextBoxComponent: FC<Props> = ({
  label,
  onChange,
  placeholder,
  required: isRequired = false,
  type = 'text',
  max,
  id,
  name,
}) => {
  const [randomId, setRandomId] = useState<string>();
  
  const randomNumber = Math.floor(Math.random() * 100);

  useEffect(() => {
    if (id) {
      setRandomId(id);
      return;
    }
    setRandomId(`id-${randomNumber}`);
  }, []);
  return (
    <div>
      {label && <LabelComponent label={label} id={randomId} />}
      <input
        type={type}
        className="border-2 rounded-lg border-gray-300 px-5 py-1 w-full bg-white decoration-gray-300 text-neutral-800"
        placeholder={placeholder}
        onChange={onChange}
        required={isRequired}
        max={max}
        id={randomId}
        name={name}
      />
    </div>
  );
};

export default TextBoxComponent;
